import React, { useEffect, useState } from "react";
import Select from "react-select";
import Header from "../Header/Header.js";
import Footer from "../Footer/Footer.js";
import { useQuery } from "@apollo/client";
import { GET_PAYMENT_ORDERS } from "../graphql/Query/Order.js";
import { capitalizeFirstLetter } from "../OrderPage/AllOrders.js";
import * as XLSX from 'xlsx'
import SpinLoader from "../components/SpinLoader.js";
import moment from "moment";
import { Link } from "react-router-dom";
import NoDataFound from "../components/NoDataFound.js";
import { FiDownload } from "react-icons/fi";
import CustomPagination from "../components/Pagination.js";
import { warehouseOptions } from "./AllOrderSeller.js";
import Loader from "../components/Loader.js";
import { GET_CUSTOMER_PAYMENT_TRANSACTION } from "../graphql/Query/SellerTransaction.js";


const typeOptions = [
    { value: "", label: "All" },
    { value: "delivered", label: "Delivered" },
    { value: "rto", label: "RTO" },
];



const AllPaymentSeller = () => {
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [pagePayment, setPagePayment] = useState(0);
    const [limitPayment, setLimitPayment] = useState(15);
    const [filter, setFilter] = useState('');
    const [orderData, setOrderData] = useState([]);
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [selectedDayRange, setSelectedDayRange] = useState(""); // Logical value
    const [searchUser, setSearchUser] = useState('');
    const [cod_payment_status, setcod_payment_status] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    const [orderStatus, setorderStatus] = useState('');
    const [orderStatusData, setorderStatusData] = useState('');

    const [displayedDayRange, setDisplayedDayRange] = useState({ label: "All", value: "" }); // Displayed value

    const { data: GetOrderOrder, loading } = useQuery(GET_PAYMENT_ORDERS, {
        variables: {
            page: page + 1,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": filter.trim(),
            "from": fromDate,
            "to": toDate,
            "orderStatus": orderStatus,
            "codPaymentStatus": cod_payment_status,
            dayRange: selectedDayRange
        },
        fetchPolicy: "cache-and-network"
    })

    const { data: GetOrderOrderData, loadingData } = useQuery(GET_CUSTOMER_PAYMENT_TRANSACTION, {
        variables: {
            page: pagePayment + 1,
            limit: limitPayment,
            "sort": {
                "key": "createdAt",
                "type": -1
            },

        },
        fetchPolicy: "cache-and-network"
    })
    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
    }
    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(0);

    }
    useEffect(() => {
        if (GetOrderOrder?.getPaymentOrders?.data) {
            setOrderData(GetOrderOrder?.getPaymentOrders?.data);
        }
    }, [GetOrderOrder]);
    const [activeTab, setActiveTab] = useState("All");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === 'Pending Payment') {
            setcod_payment_status('pending')
        } else if (tab === 'Received Payment') {
            setcod_payment_status('success')
        } else {
            setcod_payment_status('');
        }
    };
    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
        // refetch(); // Refetch data with the new page
    };
    const handlePageClickPayment = (selectedPage) => {
        setPagePayment(selectedPage);
        // refetch(); // Refetch data with the new page
    };


    const capitalizeFirstLetter = (text) => {
        if (!text) return text;
        return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    };

    const resetData = () => {
        setPage(0);
        setToDate("");
        setFromDate("");
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('');
        setorderStatusData('');
        // setSelectedPaymentType('');
        setSelectedDayRange("")
        setDisplayedDayRange({ label: "All", value: "" }); // Display "All" in the Select dropdown
        setActiveTab('All')
    }

    const transformDataForExport = (data) => {
        return data?.map((shipment, index) => {
            return {
                No: index + 1,
                "Shipment Date": shipment?.createdAt ? moment(shipment?.createdAt).format('DD/MM/YYYY') : "-",
                "Delivered Date": shipment?.delivery_order_Date ? moment(shipment?.delivery_order_Date).format('DD/MM/YYYY') : "-",
                AWB: shipment?.awb_number || "-",
                "Order ID": shipment?.order_id || "-",
                "Order Number": shipment?.order_number || "-",
                "Payment Type": shipment?.payment_type || "-",
                "Receiver Name (To)": shipment?.deliveryAddress?.name || "-",
                State: shipment?.deliveryAddress?.stateId?.name || "-",
                Address: shipment?.deliveryAddress?.address1 || "-",
                City: shipment?.deliveryAddress?.city || "-",
                "Zip Code": shipment?.deliveryAddress?.zipCode || "-",
                "Weight (Kg)": shipment?.package_weight_Length || "-",
                Status: shipment?.status || "-",
                Product: shipment?.ProductName || "-",
                "COD Collectable Rs.": shipment?.payment_type === 'cod' ? `₹${shipment?.ProductPrice}` : "-",
                "COD Collection Rs.": shipment?.codCollectableValue || "-",
                "RTO Charges": shipment?.rto_order_charge || "0",
                "Shipment Charge": `₹${shipment?.order_amount}` || "-",
                "Total Amount": shipment?.final_order_amount || "0",
                "Total Receivable Amount": shipment?.net_receivable_amount || "0",
                "payment Status": shipment?.cod_payment_status || "-", // Ensure this is correct
                "payment_order_Date": shipment?.payment_order_Date ? moment(shipment?.payment_order_Date).format('DD/MM/YYYY HH:mm') : "-"
            };
        });
    };

    const downloadExcel = () => {
        if (!orderData?.length) return;

        const transformedData = transformDataForExport(orderData);

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Log the worksheet to verify its structure
        // console.log("Worksheet:", worksheet);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Shipments");

        // Define range
        const range = XLSX.utils.decode_range(worksheet["!ref"]);

        // Green background style for success payment status
        const greenStyle = {
            fill: { fgColor: { rgb: "00FF00" } }, // Green background
            font: { bold: true } // Bold text
        };

        for (let row = range.s.r + 1; row <= range.e.r; row++) {
            const paymentStatusCell = `U${row + 1}`; // Column U contains "payment Status"

            // Log the paymentStatusCell and its value
            // console.log(`Checking cell: ${paymentStatusCell}`, worksheet[paymentStatusCell]);

            // Check if the cell exists and has a value
            if (worksheet[paymentStatusCell] && worksheet[paymentStatusCell].v !== undefined && worksheet[paymentStatusCell].v !== null) {
                // Convert the value to a string (if it's not already) and then lowercase it
                const paymentStatus = String(worksheet[paymentStatusCell].v).toLowerCase();

                if (paymentStatus === "success") {
                    // console.log(`Row ${row + 1} has payment status "success". Applying green style.`);

                    for (let col = range.s.c; col <= range.e.c; col++) {
                        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });

                        // Log the cell being styled
                        // console.log(`Styling cell: ${cellAddress}`);

                        // Create the cell if it doesn't exist
                        if (!worksheet[cellAddress]) {
                            worksheet[cellAddress] = { v: "", t: "s" }; // Create an empty cell
                        }

                        worksheet[cellAddress].s = greenStyle; // Apply green style
                    }
                }
            }
        }

        // Write the file with styles
        XLSX.writeFile(workbook, "shipments.xlsx");
    };

    return (
        <>
            <Header />
            <div className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="bg-slate-50 border border-slate-300 p-6 rounded-lg my-6">
                    <div className="flex justify-between items-center w-full">
                        <h1 className="text-lg font-bold text-gray-800">
                            Payment History
                        </h1>
                        <button
                            onClick={downloadExcel}
                            className="flex items-center px-4 py-1 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                            <FiDownload className="mr-2 text-lg sm:text-xl" />
                            Export
                        </button>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Search Anything</label>
                            <input
                                type="text"
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Type here..."
                                value={searchUser}
                                onChange={(e) => { setSearchUser(e.target.value); handleSearch(e) }}
                            />
                        </div>


                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">AWB No.</label>
                            <input
                                type="text"
                                value={awbNumber}
                                onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter AWB No."
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Shipment IDs</label>
                            <input
                                type="text"
                                value={filterOrder}
                                onChange={(e) => { handleSearch(e, 'orderId') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter Shipment ID"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Type</label>
                            <Select
                                options={typeOptions}
                                // defaultValue={typeOptions[0]}
                                className="w-full"
                                classNamePrefix="react-select"
                                value={orderStatusData}
                                onChange={(selectedOption) => {
                                    setorderStatus(selectedOption?.value); // Update logical value
                                    setorderStatusData(selectedOption); // Update displayed value
                                }}
                                // onChange={(selectedOption) => setorderStatus(selectedOption?.value)}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#64748B' : '#64748B',
                                        '&:hover': { borderColor: '#64748B' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        borderRadius: '0.375rem',
                                        // paddingTop: '-0.5px', // py-1 corresponds to 0.25rem (4px) on top
                                        // paddingBottom: '-0.5px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        fontSize: '0.875rem',
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        fontSize: '0.875rem',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                            fontSize: '0.875rem',
                                        }
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: '0.875rem',
                                        color: '#A3AAB5',
                                    }),
                                }}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={fromDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={toDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-1">Date Range</label>
                            <Select
                                options={warehouseOptions}
                                // defaultValue={channelOptions[0]}
                                className="w-full"
                                value={displayedDayRange} // Controls the displayed value
                                onChange={(selectedOption) => {
                                    setSelectedDayRange(selectedOption?.value); // Update logical value
                                    setDisplayedDayRange(selectedOption); // Update displayed value
                                }}
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                        '&:hover': { borderColor: '#2b2b2b' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        zIndex: 1050,
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        zIndex: 1050,
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                        },
                                        zIndex: 1050,
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 1050,
                                        position: 'absolute',
                                    }),
                                }}
                            />
                        </div>

                        <div className="mt-6 flex gap-4">
                            <button className="bg-slate-500 text-white px-4 py-1 rounded-lg text-sm hover:bg-slate-600" onClick={resetData}>
                                Clear
                            </button>
                        </div>

                        {/* <div className="flex flex-col">
                        <label className="text-sm text-gray-700 mb-1">Warehouse</label>
                        <Select
                            options={warehouseOptions}
                            defaultValue={warehouseOptions[0]}
                            className="w-full"
                            classNamePrefix="react-select"
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? '#64748B' : '#64748B',
                                    '&:hover': { borderColor: '#64748B' },
                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                    borderRadius: '0.375rem',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: '#000000',
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                    color: state.isSelected ? 'white' : '#000000',
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        color: '#000000',
                                    }
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    color: '#A3AAB5',
                                }),
                            }}
                        />
                    </div> */}
                    </div>

                </div>


                {/* Tab Section */}
                <div className="bg-white px-4 py-3 border-s-0 border-r-0 border-t border-b border-slate-300 mb-4">
                    <div className="flex flex-wrap gap-4">
                        {[
                            "All",
                            "Pending Payment",
                            "Received Payment",
                            // "In Transit",
                            // "Out For Delivery",
                            // "Delivered",
                        ].map((tab) => (
                            <button
                                key={tab}
                                className={`font-semibold border-b-2 px-2 py-1 text-sm ${activeTab === tab
                                    ? "text-blue-600 border-blue-600"
                                    : "text-gray-600 border-transparent hover:text-blue-600"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                                {/* {tab !== "All" && `(${GetOrderOrder?.getPaymentOrders?.count})`} */}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Shipment Table Section */}
                <div className="bg-slate-50 rounded-t-lg border mb-9 border-slate-300">
                    <div className=" max-h-[600px] overflow-y-auto overflow-x-auto">
                        <table className="w-full text-sm text-left border-collapse whitespace-nowrap">
                            <thead className="bg-slate-100 text-gray-700 sticky top-0 z-10">
                                <tr>
                                    <th className="px-4 py-3">No.</th>
                                    <th className="px-4 py-3">Delivered Date</th>
                                    <th className="px-4 py-3">AWB No.</th>
                                    <th className="px-4 py-3">Shipment ID</th>
                                    <th className="px-4 py-3">Shipment Number</th>
                                    <th className="px-4 py-3">Receiver Details (To)</th>
                                    <th className="px-4 py-3">COD Collectable (₹)</th>
                                    <th className="px-4 py-3">COD Collection (₹)</th>
                                    <th className="px-4 py-3">Payment Type</th>
                                    <th className="px-4 py-3">RTO Charge (₹)</th>
                                    <th className="px-4 py-3">Shipment Charge (₹)</th>
                                    <th className="px-4 py-3">Total Amount (₹)</th>
                                    <th className="px-4 py-3">Net Receivable Amount (₹)</th>
                                    <th className="px-4 py-3">Receive Amount Date</th>
                                    <th className="px-4 py-3">Status</th>
                                    <th className="px-4 py-3">Receive Payment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderData?.length > 0 ? (
                                    orderData.map((shipment, index) => (
                                        <tr key={index} className="border-t bg-white">
                                            <td className="px-4 py-1 text-gray-700">{page * limit + index + 1}</td>
                                            <td className="px-4 py-1 text-gray-700">
                                                {moment(shipment?.createdAt).format('DD/MM/YYYY HH:mm')}
                                            </td>
                                            <td className="px-4 py-1 text-blue-500 underline cursor-pointer">
                                                <Link to="/singletrack" state={{ id: shipment?.id }}>
                                                    {shipment?.awb_number}
                                                </Link>
                                            </td>
                                            <td className="px-4 py-1 text-blue-500 underline cursor-pointer">
                                                {shipment?.order_id}
                                            </td>
                                            <td className="px-4 py-1 text-blue-500 underline cursor-pointer">
                                                <Link to="/singletrack" state={{ id: shipment?.id }}>
                                                    {shipment?.order_number}
                                                </Link>
                                            </td>
                                            <td className="relative  group px-4 py-1 text-gray-700">
                                                {/* Truncated address */}
                                                <div className="truncate  max-w-36" >
                                                    {capitalizeFirstLetter(shipment?.deliveryAddress?.address1)}{" "}
                                                    {capitalizeFirstLetter(shipment?.deliveryAddress?.city)}.{" "}
                                                    {capitalizeFirstLetter(shipment?.deliveryAddress?.stateId?.name)} -{" "}
                                                    {shipment?.deliveryAddress?.zipCode}
                                                </div>


                                                {/* Tooltip for full address */}
                                                <div className="absolute z-10 hidden group-hover:block bg-slate-700 text-white text-sm rounded-md px-2 py-1 shadow-lg max-w-xs whitespace-normal">
                                                    {/* Name */}
                                                    <p className="font-semibold">{shipment?.deliveryAddress?.name}</p>

                                                    {/* Package Weight & Length */}
                                                    {shipment?.package_weight_Length && (
                                                        <p className="text-sm text-gray-300">Weight: {shipment?.package_weight_Length}</p>
                                                    )}

                                                    {/* Product Name */}
                                                    {shipment?.ProductName && (
                                                        <p className="text-sm text-gray-300">Product: {shipment?.ProductName}</p>
                                                    )}

                                                    {/* Address Details */}
                                                    <p className="text-sm">
                                                        {shipment?.deliveryAddress?.address1},{" "}
                                                        {shipment?.deliveryAddress?.city}, {shipment?.deliveryAddress?.stateId?.name} -{" "}
                                                        {shipment?.deliveryAddress?.zipCode}.
                                                    </p>
                                                </div>

                                            </td>

                                            <td className="px-4 py-1 text-gray-700">
                                                {shipment?.payment_type === 'cod'
                                                    ? `₹${shipment?.ProductPrice}`
                                                    : '   -'}
                                                {/* {shipment?.package_weight_Length} */}
                                                {/* {shipment?.deliveryAddress?.city} */}
                                            </td>
                                            {/* <td className="px-4 py-1 text-gray-700">{shipment?.ProductName}</td> */}
                                            <td className="px-4 py-1 text-gray-700">₹{shipment?.codCollectableValue}</td>
                                            <td className="px-4 py-1 text-gray-700">{shipment.payment_type}</td>
                                            {/* <td className="px-4 py-1 text-gray-700">
                                                {shipment?.package_weight_Length}
                                            </td> */}
                                            <td className="px-4 py-1 text-gray-700 font-semibold">
                                                {shipment?.rto_order_charge || 0}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700">{shipment?.order_amount || 0}</td>

                                            <td className="px-4 py-1 text-gray-700">
                                                {shipment?.final_order_amount || 0}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700">
                                                {shipment?.net_receivable_amount || 0}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700 font-semibold">
                                                {/* {shipment?.payment_order_Date || '-'} */}
                                                {shipment?.payment_order_Date ? moment(shipment?.payment_order_Date).format('DD/MM/YYYY HH:mm') : '-'}
                                            </td>

                                            <td className="px-4 py-4">
                                                <span
                                                    className={`px-3 py-1 rounded-lg text-sm font-semibold ${{
                                                        delivered: "bg-green-100 text-green-600",
                                                        rto: "bg-pink-100 text-pink-600",
                                                        "rto delivered": "bg-indigo-100 text-indigo-600",
                                                    }[shipment?.status] || "bg-slate-100 text-gray-600"
                                                        }`}
                                                >
                                                    {shipment?.status}
                                                </span>
                                            </td>

                                            <td className="px-4 py-4">
                                                <span
                                                    className={`px-3 py-1 rounded-lg text-sm font-semibold ${{
                                                        pending: "bg-yellow-100 text-yellow-600",
                                                        success: "bg-green-100 text-green-600",
                                                    }[shipment?.cod_payment_status] || "bg-slate-100 text-gray-600"
                                                        }`}
                                                >
                                                    {shipment?.cod_payment_status}
                                                </span>
                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    ''
                                )}
                            </tbody>
                        </table>
                    </div>
                    {loading && (
                        <div className="my-10 mx-auto justify-end w-full">
                            <Loader className="mx-auto" />
                        </div>
                    )}
                    {orderData?.length === 0 ? <div className="w-full">
                        <td colSpan="100% " className="flex justify-center">
                            <div className="flex items-center justify-center min-h-[300px] w-full">
                                <NoDataFound />
                            </div>
                        </td>
                    </div>
                        : ''}
                </div>
                {GetOrderOrder?.getPaymentOrders?.count > 0 && (
                    <CustomPagination
                        totalItems={GetOrderOrder?.getPaymentOrders?.count || 0} // Total number of items
                        limit={limit}
                        pageNo={page} // Current page number (zero-based index)
                        handlePageClick={handlePageClick} // Handler to change page
                    />)}

                {/* Shipment Table Section */}
                <div className="w-1/2">
                    <div className="bg-slate-50 rounded-t-lg border mb-9 border-slate-300">
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left border-collapse whitespace-nowrap">
                                <thead className="bg-slate-100 text-gray-700">
                                    <tr>
                                        <th className="px-4 py-3">No.</th>
                                        <th className="px-4 py-3">Date & Time</th>
                                        <th className="px-4 py-3">Receive Payment</th>
                                        <th className="px-4 py-3">Status</th>
                                        <th className="px-4 py-3">Reference</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loadingData ? (
                                        <tr>
                                            <td colSpan="4" className="text-center py-20">
                                                <SpinLoader className="text-primary" />
                                            </td>
                                        </tr>
                                    ) : GetOrderOrderData?.getPaymentTransactionForCustomer?.count > 0 ? (
                                        GetOrderOrderData?.getPaymentTransactionForCustomer?.data.map((shipment, index) => (
                                            <tr key={index} className="border-t bg-white">
                                                <td className="px-4 py-1 text-gray-700">{pagePayment * limitPayment + index + 1}</td>
                                                <td className="px-4 py-1 text-gray-700">
                                                    {moment(shipment?.createdAt).format('DD/MM/YYYY HH:mm')}
                                                </td>
                                                <td className="px-4 py-1 text-gray-700 font-semibold">
                                                    ₹{shipment?.paymentAmount || "0"}
                                                </td>
                                                <td className="px-4 py-4">
                                                    <span
                                                        className={`bg-${shipment?.cod_payment_status === "success"
                                                            ? "green"
                                                            : shipment?.cod_payment_status === "pending" ? 'indigo' : "gray"
                                                            }-600 px-3 py-1 rounded-lg text-sm font-semibold`}
                                                    >
                                                        {shipment?.cod_payment_status || "Unknown"}
                                                    </span>
                                                </td>
                                                <td>Total {shipment?.totalShipment} Shipments</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center py-20">
                                                <NoDataFound />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <CustomPagination
                        totalItems={GetOrderOrderData?.getPaymentTransactionForCustomer?.count || 0} // Total number of items
                        limit={limitPayment}
                        pageNo={pagePayment} // Current page number (zero-based index)
                        handlePageClick={handlePageClickPayment} // Handler to change page
                    />
                </div>
            </div >
            <Footer />
        </>
    )
}

export default AllPaymentSeller
